/**
 * Auxiliares para os erros que os serviços devolvem no corpo
 * `{ message, code, details }`.
 */

/** As duas únicas mensagens que os authenticators emitem para falta de sessão. */
const SESSION_FAILURE_MESSAGES = ["Invalid Authorization", "Token Expired"];

/**
 * Alguns clients de serviço reembrulham o erro do auth-service preservando o
 * status e prefixando a mensagem — `demoteUserFromReseller`, por exemplo, devolve
 * `Failed to demote user in auth-service: Token Expired`. Por isso o sufixo
 * também conta como falha de sessão.
 */
function isSessionFailureMessage(message?: string): boolean {
  if (!message) {
    return true;
  }
  return SESSION_FAILURE_MESSAGES.some(
    (marker) => message === marker || message.endsWith(`: ${marker}`)
  );
}

/**
 * Só um 403 sem mensagem de recusa significa "token vencido, renove e repita".
 * As rotas de admin ainda respondem 403 tanto para sessão inválida quanto para
 * recusa de permissão — repetir uma recusa gasta uma requisição à toa e, onde
 * há reCAPTCHA (que é de uso único), faz o erro real chegar mascarado.
 */
export function isExpiredSession(error: any): boolean {
  const status = error?.response?.status;
  if (status === 401) {
    return true;
  }
  if (status !== 403) {
    return false;
  }
  return isSessionFailureMessage(error?.response?.data?.message);
}

/** A mensagem do backend é exibida como veio; o fallback cobre falha de rede. */
export function describeApiError(error: any, fallback: string): string {
  return error?.response?.data?.message || error?.message || fallback;
}
